module.exports = __webpack_public_path__ + "static/media/mt.07ddb919.svg";